import { Route, Routes } from "react-router/dist";
import PropertiesInventoryPage from '../pages/propertiesInventory/home/HomePage';
import CreatePropertyPage from '../pages/propertiesInventory/components/CreatePropertyInventory/CreatePropertyInventory';
import ApartmentDetailsPage from '../pages/propertiesInventory/components/ApartmentDetails';
import { ApartmentMapView } from "../pages/propertiesInventory/components/ApartmentMapView";
import SinglePropertyDetailsPage from "../pages/propertiesInventory/components/SinglePropertyDetailsPage";
import CreateApartments from "../pages/propertiesInventory/components/CreatePropertyInventory/CreateApartments";

export const PropertiesInventoryRoutes = () => {
    return (
        <Routes>
            <Route index element={<PropertiesInventoryPage />} />
            <Route path="create-property" element={<CreatePropertyPage />} />
            <Route path="complex/:id" element={<ApartmentMapView />} />
            <Route path="edit-property/:id" element={'editar complejo de propiedades'} />
            <Route path="complex/:id/apartment/:apartmentId" element={<ApartmentDetailsPage />} />
            <Route path="complex/:id/apartment/create-apartment" element={<CreateApartments />} />
            <Route path="single-property/:id" element={<SinglePropertyDetailsPage />} />
            <Route path="complex/:id/apartment/edit-apartment/:apartmentId" element={'editar apartamento'} />
        </Routes>
    );
};